import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Sheet from 'react-modal-sheet'
import cls from './modal-sheet.module.scss'
import classNames from 'classnames'
import { Button } from '@/shared/ui/buttons/Button/Button'
import Text from '../../Text/Text'
import Icon from '@material-ui/core/Icon'

export const ModalSheet = props => {
  const {
    title,
    isOpen: isOpenProp,
    instantOpen,
    onClose,
    children,
    snapPoints = [-64 - 40, 0],
    initialSnap = 0,
    mountPoint = document.body,
    isFullScreen = false,
    disableDrag = false,
    showCloseButton = false,
    theme = 'white',
    withBottomGradient = false,
    otherProps = {},
    footerConfig: {
      enableFooter,
      customFooter,
      footerButtonText = 'Подробнее',
      footerHandler,
    } = {},
  } = props

  const [isOpenEnd, setIsOpenEnd] = useState(false)
  const [isOpen, setIsOpen] = useState(instantOpen ? isOpenProp : false)

  useEffect(() => {
    if (!instantOpen) {
      requestAnimationFrame(() => {
        setIsOpen(isOpenProp)
      })
    } else {
      setIsOpen(isOpenProp)
    }
  }, [instantOpen, isOpenProp])

  const onCloseHandler = useCallback(
    e => {
      if (!isOpenEnd) return
      e.stopPropagation()
      e.preventDefault()
      onClose()
      setIsOpen(false)
    },
    [onClose, isOpenEnd],
  )

  const draggableAt = useMemo(() => {
    return snapPoints.length > 2 ? 'both' : 'top'
  }, [snapPoints])

  return (
    <Sheet
      snapPoints={isFullScreen ? [-64, 0] : snapPoints}
      initialSnap={initialSnap}
      isOpen={isOpen}
      mountPoint={mountPoint}
      className={classNames(cls.modalSheetContainer, {
        'sheet-full': isFullScreen,
      })}
      onOpenEnd={() => setIsOpenEnd(true)}
      onClose={() => {
        setIsOpen(false)
      }}
      onCloseEnd={() => {
        onClose()
        setIsOpenEnd?.(false)
      }}
      disableDrag={isFullScreen || disableDrag}
      style={{
        zIndex: null,
      }}
      {...otherProps}
    >
      <Sheet.Container
        style={{
          backgroundColor: theme === 'white' ? 'var(--color-white)' : 'var(--color-neutral-900)',
          backgroundImage: withBottomGradient
            ? 'linear-gradient(to bottom, transparent calc(100% - 100px), rgb(255 255 255 / 10%))'
            : undefined,
        }}
      >
        {!isFullScreen && <Sheet.Header />}
        {showCloseButton && (
          <button className={cls.closeButton} type="button" onClick={onCloseHandler}>
            <Icon>close</Icon>
          </button>
        )}
        {title && (
          <Text variant="h3" className={cls.title}>
            {title}
          </Text>
        )}
        <Sheet.Content>
          <Sheet.Scroller draggableAt={draggableAt}>
            <div className={cls.body}>{children}</div>
          </Sheet.Scroller>
        </Sheet.Content>
        {(enableFooter || customFooter) && (
          <div className={cls.footer}>
            {customFooter ? (
              customFooter
            ) : (
              <Button onClick={footerHandler} className={cls.footerButton}>
                {footerButtonText}
              </Button>
            )}
          </div>
        )}
      </Sheet.Container>
      <Sheet.Backdrop onClick={onCloseHandler} onTap={onCloseHandler} />
    </Sheet>
  )
}
